import { call, put, takeLatest } from 'redux-saga/effects';

import { fetchCountApi } from '../../api';
import {
  fetchCountData,
  countDataSuccess,
  countDataError,
} from '../slices/countSlice';

function* fetchCountDataWorker(action) {
  try {
    const { status, ok, data } = yield call(fetchCountApi, action.payload);

    if (ok) {
      yield put(countDataSuccess(data));
    } else {
      yield put(countDataError({ status, data }));
    }
  } catch (err) {
    throw new Error(`Error: ${err.message}`);
  }
}

export default function* countSaga() {
  yield takeLatest(fetchCountData.type, fetchCountDataWorker);
}
